import axiosService from './axiosService';

class GeneralServices {
  GetIdentificationTypes = async () => axiosService.get('/api/identification-types');
}

const generalServices = new GeneralServices();
export default generalServices;
